import React from 'react'
import { FaHtml5, FaCss3, FaReact, FaSass, FaJs,  FaGithub, FaNodeJs } from 'react-icons/fa'
import {  Bounce } from "react-awesome-reveal";

import {  ReduxOriginal, FirebasePlain, TailwindcssPlain, GitPlain, MongodbPlain, JavaPlain, TypescriptPlain,  ExpressOriginal, DockerPlain } from 'devicons-react'

const Technology = ({ children, name }) => {
    return <>
        <div className='p-4 w-20 bg-gray-500 bg-opacity-5 flex flex-col items-center justify-center gap-3'>
            <span>
                {children}
            </span>
            <span className='text-center'>
                {name}
            </span>
        </div>
    </>
}

const About = () => {
    return (
        <>
            <section className=' lg:w-[500px] flex flex-col gap-5 my-10 h-full' id='about'>
                <h2 className='font-bold text-left text-xl uppercase opacity-80'>
                    About
                </h2>

                <p className='text-base capitalize font-[400] tracking-wider'>

                    As a software engineer, I am deeply passionate about my craft. I thrive on learning and embracing emerging technologies, staying abreast of the industry's latest trends. My expertise extends to React, a widely-used JavaScript library for constructing user interfaces.
                    <br />
                </p>
                <p className='text-base capitalize font-[400] tracking-wider'>
                    Currently, I am actively engaged in constructing backend APIs and services, expanding my interests into this pivotal domain. This diversified experience contributes to my holistic understanding of software engineering, enabling me to bring a comprehensive skill set to the table.
                </p>

                <p className='text-base capitalize font-[400] tracking-wider'>
                    I approach challenges with determination, consistently demonstrating a willingness to go to great lengths to devise effective solutions. My commitment to overcoming obstacles aligns with my passion for creating robust and efficient software solutions.
                </p>


                <p className='text-base capitalize font-[400] tracking-wider'>
                    I play games, learn new languages and watch football when I am not coding.
                </p>

            </section>

            <section className=' lg:w-[500px] flex flex-col gap-5 my-10 h-full'>

                <h2 className='font-bold text-left text-xl uppercase opacity-1000'>

                    The Technologies I work with

                </h2>

                <Bounce triggerOnce={true}>
                    <section className='grid lg:grid-cols-4 grid-cols-3 md:grid-cols-4 items-center  place-items-start justify-center gap-y-4 gap-x-5' id='technologies'>

                        <Technology name={"HTML"}>
                            <FaHtml5 size={50} />
                        </Technology>

                        <Technology name={"CSS"}>
                            <FaCss3 size={50} />
                        </Technology>
                        <Technology name={"Javascript"}>
                            <FaJs size={35} />
                        </Technology>
                        <Technology name={"Sass"}>
                            <FaSass size={35} />
                        </Technology>
                        <Technology name={"NodeJs"}>
                            <FaNodeJs size={35} />
                        </Technology>
                        <Technology name={"React"}>
                            <FaReact size={35} />
                        </Technology>
                        <Technology name={"Redux"}>
                            <ReduxOriginal size={35} color='pink' />
                        </Technology>
                        <Technology name={"Firebase"}>
                            <FirebasePlain size={35} color='white' />
                        </Technology>
                        <Technology name={"TailWind"}>
                            <TailwindcssPlain size={35} color='white' />
                        </Technology>
                        <Technology name={"Git"}>
                            <GitPlain size={35} color='white' />
                        </Technology>
                        <Technology name={"GitHub"}>
                            <FaGithub size={35} color='white' />
                        </Technology>
                        <Technology name={"TypeScript"}>
                            <TypescriptPlain size={35} color='white' />
                        </Technology>
                        <Technology name={"Java"}>
                            <JavaPlain size={35} color='white' />
                        </Technology>
                        <Technology name={"MongoDB"}>
                            <MongodbPlain size={35} color='white' />
                        </Technology>
                        <Technology name={"Express"}>
                            <ExpressOriginal size={35} color='white' />
                        </Technology>
                        <Technology name={"Docker"}>
                            <DockerPlain size={35} color='white' />
                        </Technology>



                    </section>
                </Bounce>

            </section>
        </>
    )
}

export default About